import {
   getNextAllowedHourInterval,
   getNextMultiple,
   getPreviousAllowedHourInterval,
   getPreviousMultiple,
} from '~libs.shared.prescription';

import { DosagePeriodAmountSteps } from './DosagePeriodField.types';

export const ALLOWED_HOUR_INTERVAL_STEPS: DosagePeriodAmountSteps = {
   increment: getNextAllowedHourInterval,
   decrement: getPreviousAllowedHourInterval,
};

export const getMultipleSteps = (multiplier: number): DosagePeriodAmountSteps => ({
   increment: (amount: number): number => getNextMultiple(amount, multiplier),
   decrement: (amount: number): number => getPreviousMultiple(amount, multiplier),
});
